import types from '../../types';

const account = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_ACCOUNT_START:
      return { ...state, loading: true };

    case types.GET_ACCOUNT_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_ACCOUNT_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default account;
